// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"30c6a731","93":"0329d975","654":"0c259cd2","687":"b9168f87","842":"b7c99b3b"}[chunkId] + ".chunk.js";
};